/* ==========================================================
   CART DRAWER — Shanty Biscuits
   Vanilla JS, sans dépendance. Rafraîchit la section
   "cart-drawer" via la Section Rendering API de Shopify.
   ========================================================== */
(function () {
  'use strict';

  var drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SECTION_ID = drawer.getAttribute('data-section-id') || 'cart-drawer';
  var PARTS = ['count', 'tiers', 'items', 'crosssell', 'footer'];
  var nativeFetch = window.fetch.bind(window);
  var lastFocus = null;
  var busy = false;

  /* ---------------- Helpers ---------------- */
  function $(sel, ctx) { return (ctx || drawer).querySelector(sel); }

  function request(path, body) {
    var opts = { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body instanceof FormData) {
      body.append('sections', SECTION_ID);
      body.append('sections_url', window.location.pathname);
      opts.body = body;
    } else {
      body = body || {};
      body.sections = SECTION_ID;
      body.sections_url = window.location.pathname;
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return nativeFetch(ROOT + path, opts).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) {
          var msg = (data && (data.description || data.message)) || 'Une erreur est survenue.';
          throw new Error(msg);
        }
        return data;
      });
    });
  }

  function fetchSection() {
    return nativeFetch(ROOT + '?sections=' + SECTION_ID, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (json) { return json[SECTION_ID]; });
  }

  function setLoading(on) {
    busy = on;
    drawer.classList.toggle('is-loading', on);
  }

  function showError(msg) {
    var el = $('[data-cd-error]');
    if (!el) return;
    if (!msg) { el.hidden = true; el.textContent = ''; return; }
    el.textContent = msg;
    el.hidden = false;
  }

  /* ---------------- Rendu ---------------- */
  function render(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('CartDrawer');
    if (!fresh) return;

    PARTS.forEach(function (name) {
      var from = fresh.querySelector('[data-cd-part="' + name + '"]');
      var to = drawer.querySelector('[data-cd-part="' + name + '"]');
      if (from && to) to.innerHTML = from.innerHTML;
    });

    var count = parseInt(fresh.getAttribute('data-item-count'), 10) || 0;
    drawer.setAttribute('data-item-count', count);
    ['[data-cd-card]', '[data-cd-date]', '[data-cd-note-block]'].forEach(function (sel) {
      var el = $(sel);
      if (el) el.hidden = count === 0;
    });
    updateHeaderCount(count);
    initCrossSell();
  }

  /* ---------------- Cross-sell : slider + variantes ---------------- */
  function csVariant(form) {
    var field = form.querySelector('[name="id"]');
    var src = field.tagName === 'SELECT' ? (field.options[field.selectedIndex] || field.options[0]) : field;
    if (!src) return { id: field.value, min: 1, price: null };
    return {
      id: field.value,
      min: parseInt(src.getAttribute('data-min'), 10) || 1,
      price: src.getAttribute('data-price')
    };
  }

  function updateCsForm(form) {
    var v = csVariant(form);
    var price = form.querySelector('[data-cd-cs-price]');
    if (price && v.price) price.textContent = v.price;
    var min = form.querySelector('[data-cd-cs-min]');
    if (min) {
      min.hidden = v.min <= 1;
      min.textContent = v.min > 1 ? 'Ajouté par ' + v.min + ' (min.)' : '';
    }
  }

  function updateArrows() {
    var list = $('[data-cd-cs-list]');
    if (!list) return;
    var prev = $('[data-cd-cs-nav="-1"]');
    var next = $('[data-cd-cs-nav="1"]');
    var max = list.scrollWidth - list.clientWidth - 2;
    var scrollable = max > 0;
    $('.cd-cs__slider').classList.toggle('is-static', !scrollable);
    if (prev) prev.disabled = list.scrollLeft <= 2;
    if (next) next.disabled = list.scrollLeft >= max;
  }

  function initCrossSell() {
    drawer.querySelectorAll('[data-cd-cs-form]').forEach(updateCsForm);
    var list = $('[data-cd-cs-list]');
    if (list && !list._cdBound) {
      list._cdBound = true;
      list.addEventListener('scroll', function () { window.requestAnimationFrame(updateArrows); }, { passive: true });
    }
    updateArrows();
  }

  drawer.addEventListener('change', function (e) {
    if (e.target.matches('[data-cd-cs-select]')) updateCsForm(e.target.closest('form'));
  });
  window.addEventListener('resize', updateArrows);

  /* Cadeau automatique (assets/gift-auto.js) : ajouté / retiré selon le seuil */
  function syncGift() {
    if (!window.ShantyGift) return Promise.resolve(false);
    return window.ShantyGift.sync();
  }

  function refresh(data) {
    var p;
    if (data && data.sections && data.sections[SECTION_ID]) {
      render(data.sections[SECTION_ID]);
      p = Promise.resolve();
    } else {
      p = fetchSection().then(render);
    }
    return p.then(syncGift).then(function (changed) {
      if (changed) return fetchSection().then(render);
    });
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('.cart-shanty__link').forEach(function (link) {
      var bubble = link.querySelector('.cart-item-count');
      if (count > 0) {
        if (!bubble) {
          bubble = document.createElement('span');
          bubble.className = 'cart-item-count';
          link.insertBefore(bubble, link.firstChild);
        }
        bubble.textContent = count;
      } else if (bubble) {
        bubble.parentNode.removeChild(bubble);
      }
    });
  }

  /* ---------------- Ouverture / fermeture ---------------- */
  function open() {
    if (drawer.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cd-lock');
    initCrossSell();
    var panel = $('.cd__panel');
    setTimeout(function () { panel && panel.focus(); }, 50);
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cd-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function refreshAndOpen() {
    showError(null);
    return syncGift().then(fetchSection).then(render).then(open);
  }

  /* ---------------- Mutations panier ---------------- */
  function change(key, quantity) {
    if (busy) return;
    setLoading(true);
    showError(null);
    request('cart/change.js', { id: key, quantity: quantity })
      .then(refresh)
      .catch(function (e) { showError(e.message); return fetchSection().then(render); })
      .then(function () { setLoading(false); });
  }

  function add(payload, done) {
    setLoading(true);
    showError(null);
    return request('cart/add.js', payload)
      .then(refresh)
      .then(function () { if (done) done(); open(); })
      .catch(function (e) { showError(e.message); open(); })
      .then(function () { setLoading(false); });
  }

  /* ---------------- Clics dans le drawer ---------------- */
  drawer.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('[data-cd-close]')) { e.preventDefault(); close(); return; }

    var nav = t.closest('[data-cd-cs-nav]');
    if (nav) {
      var list = $('[data-cd-cs-list]');
      var item = list && list.querySelector('.cd-cs__item');
      var step = item ? item.getBoundingClientRect().width + 12 : list.clientWidth * 0.8;
      list.scrollBy({ left: step * parseInt(nav.getAttribute('data-cd-cs-nav'), 10), behavior: 'smooth' });
      return;
    }

    var qtyBtn = t.closest('[data-cd-qty]');
    if (qtyBtn) {
      var item = qtyBtn.closest('.cd-item');
      var qtyWrap = qtyBtn.closest('.cd-qty');
      var current = parseInt(qtyWrap.querySelector('.cd-qty__value').textContent, 10) || 0;
      var min = parseInt(qtyWrap.getAttribute('data-min'), 10) || 1;
      var step = parseInt(qtyWrap.getAttribute('data-step'), 10) || 1;
      var next = qtyBtn.getAttribute('data-cd-qty') === 'plus' ? current + step : current - step;
      if (next < min) return;
      qtyWrap.querySelector('.cd-qty__value').textContent = next;
      change(item.getAttribute('data-key'), next);
      return;
    }

    var removeBtn = t.closest('[data-cd-remove]');
    if (removeBtn) {
      change(removeBtn.closest('.cd-item').getAttribute('data-key'), 0);
      return;
    }

    /* Carte personnalisée */
    if (t.closest('[data-cd-card-open]')) {
      $('[data-cd-card-open]').hidden = true;
      $('[data-cd-card-form]').hidden = false;
      $('#CartDrawer-card-text').focus();
      return;
    }
    if (t.closest('[data-cd-card-cancel]')) {
      resetCard();
      return;
    }

    /* Datepicker */
    var dateToggle = t.closest('[data-cd-date-toggle]');
    if (dateToggle) {
      var content = $('[data-cd-date-content]');
      var expanded = dateToggle.getAttribute('aria-expanded') === 'true';
      dateToggle.setAttribute('aria-expanded', String(!expanded));
      content.hidden = expanded;
      if (!expanded) initDatepicker();
      return;
    }
    if (t.closest('[data-cd-date-clear]')) {
      if (datepicker) datepicker.setDate({ clear: true });
      saveDeliveryWeek(null);
    }
  });

  function resetCard() {
    var form = $('[data-cd-card-form]');
    if (!form) return;
    form.reset();
    form.hidden = true;
    $('[data-cd-card-open]').hidden = false;
    var c = $('[data-cd-card-count]');
    if (c) c.textContent = '0';
  }

  drawer.addEventListener('input', function (e) {
    if (e.target.id === 'CartDrawer-card-text') {
      var c = $('[data-cd-card-count]');
      if (c) c.textContent = e.target.value.length;
    }
  });

  /* Note de commande (enregistrée automatiquement) */
  var noteTimer;
  drawer.addEventListener('input', function (e) {
    if (!e.target.matches('[data-cd-note]')) return;
    clearTimeout(noteTimer);
    var value = e.target.value;
    noteTimer = setTimeout(function () {
      request('cart/update.js', { note: value }).catch(function () {});
    }, 600);
  });

  /* Formulaires internes : carte + cross-sell */
  drawer.addEventListener('submit', function (e) {
    var form = e.target;

    if (form.matches('[data-cd-card-form]')) {
      e.preventDefault();
      var text = form.querySelector('textarea').value.trim();
      if (!text) return;
      var id = $('[data-cd-card]').getAttribute('data-variant-id');
      add({ items: [{ id: id, quantity: 1, properties: { Texte: text } }] }, resetCard);
      return;
    }

    if (form.matches('[data-cd-cs-form]')) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;
      var v = csVariant(form);
      add({ items: [{ id: v.id, quantity: v.min }] });
    }
  });

  /* ---------------- Datepicker "Livraison semaine du" ---------------- */
  var datepicker = null;
  var DP_SRC = 'https://cdn.jsdelivr.net/npm/vanillajs-datepicker@1.3.1/dist/js/datepicker-full.min.js';
  var DAY = 24 * 60 * 60 * 1000;

  function getMonday(date) {
    var day = date.getDay();
    var offset = day > 0 ? 1 - day : -6;
    return new Date(date.getTime() + offset * DAY);
  }

  function loadDatepickerLib(cb) {
    if (window.Datepicker) return cb();
    var existing = document.querySelector('script[src="' + DP_SRC + '"]');
    if (existing) { existing.addEventListener('load', cb); return; }
    var s = document.createElement('script');
    s.src = DP_SRC;
    s.onload = cb;
    document.body.appendChild(s);
  }

  function saveDeliveryWeek(startDate) {
    var clear = $('[data-cd-date-clear]');
    if (clear) clear.hidden = !startDate;
    return request('cart/update.js', {
      attributes: { 'Livraison semaine du': startDate ? startDate.toLocaleDateString('fr-FR') : null }
    }).catch(function (e) { showError(e.message); });
  }

  function initDatepicker() {
    if (datepicker) return;
    loadDatepickerLib(function () {
      var Datepicker = window.Datepicker;
      if (!Datepicker || datepicker) return;
      Datepicker.locales.fr = {
        days: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
        daysShort: ['dim', 'lun', 'mar', 'mer', 'jeu', 'ven', 'sam'],
        daysMin: ['di', 'lu', 'ma', 'me', 'je', 've', 'sa'],
        months: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'],
        monthsShort: ['jan', 'fév', 'mar', 'avr', 'mai', 'jun', 'jul', 'aoû', 'sep', 'oct', 'nov', 'déc'],
        today: "Aujourd'hui",
        clear: 'Effacer',
        titleFormat: 'MM y',
        format: 'dd/mm/yyyy',
        weekStart: 1
      };

      var input = drawer.querySelector('#CartDrawer-date input[name="start"]');
      var selectedMonday = null;
      if (input.value) {
        var p = input.value.split('/').map(function (a) { return parseInt(a, 10); });
        selectedMonday = new Date(p[2], p[1] - 1, p[0]);
      }

      datepicker = new Datepicker(input, {
        language: 'fr',
        container: '#CartDrawer-date-wrap',
        orientation: 'bottom left',
        autohide: true,
        datesDisabled: function (date) {
          var endOfThisWeek = new Date(getMonday(new Date()).getTime() + 6 * DAY);
          return date < endOfThisWeek;
        },
        beforeShowDay: function (date) {
          if (!selectedMonday) return;
          var diff = date.getTime() - selectedMonday.getTime();
          if (diff >= 0 && diff < 7 * DAY) return { classes: 'cd-week' };
        }
      });
      if (selectedMonday) datepicker.setDate(selectedMonday, { render: false });

      input.addEventListener('changeDate', function (evt) {
        var date = evt.detail && evt.detail.date;
        if (!date) return;
        var monday = getMonday(date);
        monday.setHours(0, 0, 0, 0);
        selectedMonday = monday;
        if (date.getTime() !== monday.getTime()) {
          datepicker.setDate(monday); /* relance changeDate avec le lundi */
          return;
        }
        datepicker.refresh('picker', true);
        saveDeliveryWeek(monday);
      });
    });
  }

  /* ---------------- Fermeture clavier ---------------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  /* ---------------- Icône panier du header ---------------- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.cart-shanty__link, [data-open-cart-drawer]');
    if (!link) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    e.stopPropagation();
    refreshAndOpen();
  }, true); /* phase de capture : passe avant les autres scripts du header */

  /* ---------------- Ajouts au panier depuis le site ----------------
     1) Formulaires classiques action="/cart/add" (fiches produit du thème)
        -> écouté sur window pour passer APRÈS les validations des autres scripts. */
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (e.defaultPrevented || !form || !form.getAttribute) return;
    var action = form.getAttribute('action') || '';
    if (!/\/cart\/add(\.js)?(\?|$)/.test(action)) return;
    if (drawer.contains(form) || form.hasAttribute('data-no-drawer')) return;

    e.preventDefault();
    var fd = new FormData(form);
    if (!fd.get('quantity')) fd.set('quantity', '1');
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');

    request('cart/add.js', fd)
      .then(refresh)
      .then(open)
      .catch(function (err) {
        showError(err.message);
        open();
      })
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  });

  /* 2) Ajouts AJAX faits par d'autres scripts (PageFly, apps...) */
  function isAddUrl(url) {
    return typeof url === 'string' && /\/cart\/add(\.js)?(\?|$)/.test(url);
  }
  var pending = null;
  function externalAdded() {
    clearTimeout(pending);
    pending = setTimeout(refreshAndOpen, 150);
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    var fromGift = init && init.headers && init.headers['X-Shanty-Gift'];
    if (isAddUrl(url) && !fromGift) {
      p.then(function (res) { if (res.ok) externalAdded(); }).catch(function () {});
    }
    return p;
  };

  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isAddUrl(url)) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) externalAdded();
      });
    }
    return xhrOpen.apply(this, arguments);
  };

  initCrossSell();

  /* API publique (pour tests ou autres scripts) */
  window.ShantyCartDrawer = { open: refreshAndOpen, close: close, refresh: function () { return fetchSection().then(render); } };
})();
